export interface ExperienceLevel {
  id: number
  description: string
}

export enum YearsOfExperience {
  LESS_THAN_1_YEAR = 'Less than 1 year',
  ONE_TO_THREE_YEARS = '1 - 3 years',
  THREE_TO_FIVE_YEARS = '3 - 5 years',
  FIVE_TO_SEVEN_YEARS = '5 - 7 years',
  OVER_7_YEARS = 'Over 7 years',
}

export const YEARS_OF_EXPERIENCE_OPTIONS = Object.values(YearsOfExperience)

export const YEARS_OF_EXPERIENCE_PILLS_DESCRIPTIONS = [
  { id: YearsOfExperience.LESS_THAN_1_YEAR, description: '< 1 year' },
  { id: YearsOfExperience.ONE_TO_THREE_YEARS, description: '1-3 years' },
  { id: YearsOfExperience.THREE_TO_FIVE_YEARS, description: '3-5 yrs' },
  { id: YearsOfExperience.FIVE_TO_SEVEN_YEARS, description: '5-7 yrs' },
  { id: YearsOfExperience.OVER_7_YEARS, description: '> 7 yrs' },
]

export interface TechnologyList {
  id: number
  name: string
}

export interface TechStackList {
  idTechnology: number
  idExperienceLevel: number
  yearsOfExperience?: YearsOfExperience | null
}
